import { render, staticRenderFns } from "./PinEditorUI.vue?vue&type=template&id=a68e8f54&scoped=true&"
import script from "./PinEditorUI.vue?vue&type=script&lang=js&"
export * from "./PinEditorUI.vue?vue&type=script&lang=js&"
import style0 from "./PinEditorUI.vue?vue&type=style&index=0&id=a68e8f54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a68e8f54",
  null
  
)

export default component.exports